import React, { useEffect, useState  } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url,Apitoken, Authtoken  } from "../Global";
import "react-toastify/dist/ReactToastify.css";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';

import { loader_image } from "../_components/Imagepath";
import Select from 'react-select';
import $ from "jquery";
import Swal from 'sweetalert2';
// import {
//   MenuItem,
// } from '@mui/material';
const ProductionOrders = () => {
  const [menu, setMenu] = useState(false);

  const [productionStatusOptions, setProductionStatusOptions] = useState([]);
  const [permission, setPermission] = useState({});

  const [contractslist, setContractslist] = useState([]);

  const [data, setData] = useState([]);
     const [dataConfirmed, setDataConfirmed] = useState([]);
     const [dataFinished, setDataFinished] = useState([]);
     const [dataInproduction, setDataInproduction] = useState([]);
     const [dataCancelled, setDataCancelled] = useState([]);
     const [dataDraft, setDataDraft] = useState([]);
     const [dataShipped, setDataShipped] = useState([]);
     const [dataDelivered, setDataDelivered] = useState([]);

  const options = [
   { value: '1', label: "Confirmed" },
    { value: '2', label: "Finished" },
    { value: '3', label: "In Process" },
    { value: '4', label: "Draft" },
    { value: '5', label: "Cancelled" },
    { value: '6', label: "Shipped" },
    { value: '7', label: "Delivered" },
  ];


  const handleSelectChange = (selectedOptions) => {
    setFormData({ ...formData, order_stats: selectedOptions ? selectedOptions.map(option => option.value) : [] });
  };
   const handleSelectChangeCustomer = (selectedOption) => {
    setFormData({ ...formData, contract: selectedOption ? selectedOption.value : null });
  };
  

  const [formData, setFormData] = useState({
    contract:'',
    order_stats: [],
   
    
  });
 


  const handleSubmit = (e) => {
    e.preventDefault();


    axios
    .post("/orders/filtered-list", formData, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }) .then((response) => {
   

      if (response.data.code === 200) {
           let all_orders  =response.data.data.orders;
          let order_Confirmed = [];
          let order_Finished = [];
          let order_InProcess = [];
          let order_Draft = [];
          let order_Cancelled = [];
          let order_Shipped = [];
          let order_Delivered = [];
        all_orders.forEach((order) => {
            switch (order.order_status) {
              case 1:
                order_Confirmed.push(order);
              break;
              case 2:
                order_Finished.push(order);
              break;
              case 3:
                order_InProcess.push(order);
              break;
              case 4:
                order_Draft.push(order);
              break;
              case 5:
                order_Cancelled.push(order);
              break;
              case 6:
                order_Shipped.push(order);
              break;
              case 7:
                order_Delivered.push(order);
              break;
            
              default:
                break;
            }
          });
          setData(all_orders);
          setDataConfirmed(order_Confirmed);
          setDataFinished(order_Finished);
          setDataInproduction(order_InProcess);
          setDataDraft(order_Draft);
          setDataCancelled(order_Cancelled);
          setDataShipped(order_Shipped);
          setDataDelivered(order_Delivered);
        
        $("#filtered-excel-button").show();

       

      } 
      else {
         //setBackendErrors(response.data.error);
      }
    })
    .catch((error) => {
      console.log(error)
     // actions.setSubmitting(false);
    });
  
  }
 

  useEffect(() => {
        setPermission(FindModuleById(401)); 
      console.log(permission);

   
        axios.post("/contracts/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }}).
          then((response) => {
            if (response.data.code === 200) {
              let incoterms = response.data.data.contracts;
              let contractslisting = incoterms.map((cust, index) => ({
                label: cust.contract_number,
                value: cust.id,
                key: `types-${index}`,
              }));
              setContractslist(contractslisting);
            }
     
    })
    .catch((error) => {
      console.log(error);
    });

    axios.post("/orders-production/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {

                let all_orders  =response.data.data.orders;
          let order_Confirmed = [];
          let order_Finished = [];
          let order_InProcess = [];
          let order_Draft = [];
          let order_Cancelled = [];
          let order_Shipped = [];
          let order_Delivered = [];
        all_orders.forEach((order) => {
            switch (order.order_status) {
              case 1:
                order_Confirmed.push(order);
              break;
              case 2:
                order_Finished.push(order);
              break;
              case 3:
                order_InProcess.push(order);
              break;
              case 4:
                order_Draft.push(order);
              break;
              case 5:
                order_Cancelled.push(order);
              break;
              case 6:
                order_Shipped.push(order);
              break;
              case 7:
                order_Delivered.push(order);
              break;
            
              default:
                break;
            }
          });
          setData(all_orders);
          setDataConfirmed(order_Confirmed);
          setDataFinished(order_Finished);
          setDataInproduction(order_InProcess);
          setDataDraft(order_Draft);
          setDataCancelled(order_Cancelled);
          setDataShipped(order_Shipped);
          setDataDelivered(order_Delivered);
  


      }).catch((error) => {console.log(error);});




    axios
      .get("/helpers/production-orders-status", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let orders_status = response.data.data.orders_status;
          setProductionStatusOptions(orders_status);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
   
  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



const updateDate = async (id,type) =>{



  //  const showDateInputAlert = async () => {
      const { value: date } = await  Swal.fire({
        title: 'Update Production Date',
        html: '<input type="date" id="datePicker" class="swal2-input">',
        showCancelButton: true,
        confirmButtonText: 'Update',
        cancelButtonText: 'Cancel',
        customClass: "swal-orders",
        preConfirm: () => {
          return document.getElementById('datePicker').value;
        }
      });
     
      if (date) {
        // Do something with the selected date
        console.log('Selected date:', date);
            axios.get(`/production-orders/update-production-date/${id}/${date}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              console.log(response);
              
              if (response.data.code === 200) {
                $("#button-"+type+"-"+id).text(response.data.data.date);
                Swal.fire(
                  'Changed!',
                  'Date Updated Successfully.',
                  'success'
                );
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
      }

}
   const ProductionDateCell = ({ row, permission, updateDate }) => {
    const { original } = row;
  
    return (
      <div>
        {permission?.update === 1 ? (
          <button
            className="btn btn-primary btn-block"
            id={`button-all-${original.id}`}
            onClick={() => updateDate(original.id, 'all')}
          >
            {original.planned_production_date ?? 'Update Date'}
          </button>
        ) : (
          <span>{original.planned_production_date ?? 'N/A'}</span>
        )}
      </div>
    );
  };
  
  
  // ✅ Define PropTypes
  ProductionDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        planned_production_date: PropTypes.string,
      }).isRequired,
    }).isRequired,
    permission: PropTypes.shape({
      update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    updateDate: PropTypes.func.isRequired,
  };
  
  
  
  const PONumberCell = ({ row }) => {
    return (
      <a href='#' className="">
        {row.original.po_number}
      </a>
    );
  };
  
  // ✅ Define PropTypes
  PONumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        po_number: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  const OrderStatusCell = ({ row,  changeOrderStatus}) => {

    console.log(productionStatusOptions);
    console.log(row.original.order_status);
      if(row.original.order_status === 1 || row.original.order_status === 2 || row.original.order_status === 3){
         return (
      <div className="btn-group custom-table-btn-group">
        <button
          type="button"
          className="btn btn-block dropdown-toggle me-1"
          id={`status-all-${row.original.id}`}
          style={{
            backgroundColor: row.original.status.bg_color,
            color: row.original.status.color,
          }}
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {row.original.status ? row.original.status.title : ''}
        </button>
        <div className="dropdown-menu">
          {productionStatusOptions &&
            productionStatusOptions.map((shipp) => (
              <button
                key={shipp.id}
                className="dropdown-item btn btn-block"
                style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
                onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
              >
                {shipp.title}
              </button>
            ))}
        </div>
      </div>
    );
        
      }else{
      return (
        <button
          type="button"
          className="btn btn-block  me-1"
          style={{
            backgroundColor: row.original.status.bg_color,
            color: row.original.status.color,
          }}
        
        >
          {row.original.status ? row.original.status.title : ''}
        </button>
   
    );
      }
    
   
  };
  

  OrderStatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      order_status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // ✅ Added this line
      status: PropTypes.shape({
        title: PropTypes.string,
        bg_color: PropTypes.string,
        color: PropTypes.string,
      }),
    }).isRequired,
  }).isRequired,
  statusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      bg_color: PropTypes.string,
      color: PropTypes.string,
    })
  ).isRequired,
  changeOrderStatus: PropTypes.func.isRequired,
};

  const columns = [
    {
      header: 'PO Number',
      accessorFn: (row) => `${row.po_number}`,
      Cell: PONumberCell, // ✅ Use the separate component
    },
    {
      header: 'Customer',
      accessorFn: (row) => `${row.customer_detail ? row.customer_detail.company_name : ''}`,
    },
    {
      header: 'Contract',
      accessorFn: (row) => `${row.contract_detail ? row.contract_detail.contract_number : ''}`,
    },
     {
        header: 'Production Date',
        accessorFn: (row) => row.planned_production_date || '',
        Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      },
    {
      accessorKey: 'quantity', //normal accessorKey
      header: 'Quantity',
    },
    {
      accessorKey: 'lot_number', //normal accessorKey
      header: 'Lot Number',
    },
    {
      header: 'Processing Line',
      accessorFn: (row) => `${(row.order_location)?row.order_location.title:""} `,
    },
    {
      header: 'Order Status',
      accessorFn: (row) => `${row.status ? row.status.title : ''}`,
      Cell: (props) => <OrderStatusCell {...props}  changeOrderStatus={changeOrderStatus}  />,
    },
    {
      header: 'Shipping Address',
      accessorFn: (row) => `${row.ship_address2 ? row.ship_address2.name : ''}`,
    },
   
    {
      header: 'Shipping method',
      accessorFn: (row) => `${row.shipping_method ? row.shipping_method : ''}`,
    },
    {
      header: 'Loading Type',
      accessorFn: (row) => `${row?.loading_type === 2 ? 'Pallets Loaded' : 'Floor Loaded'}`,
    },

    {
      header: 'Created By',
      accessorFn: (row) =>
        `${row.createdby ? row.createdby.first_name + ' ' + row.createdby.last_name : ''}`,
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        `${row.updatedby ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ''}`,
    },
    {
      header: 'Updated At',
      accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
    },
  ];
  
  
 

      
          const formatDateTime = (isoString) => {
            const date = new Date(isoString);
          
            // Get the components
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, '0');
          
            // Determine AM/PM
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert to 12-hour format
          
            return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
          };
    
    const changeOrderStatus = (user_id, status,type) =>{

    Swal.fire({
      title: 'Do you want Change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/orders/change-status/${user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              console.log(response.data.data.order_status);
              if (response.data.code === 200) {
                $("#status-"+type+"-"+user_id).text(response.data.data.order_status.title);
                $("#status-"+type+"-"+user_id).css('background-color',response.data.data.order_status.bg_color);
                $("#status-"+type+"-"+user_id).css('color',response.data.data.order_status.color);

                
                  axios.post("/orders-production/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
                  
                              .then((response) => {
                                if (response.data.code === 200) {
                                  
                                  let all_orders  =response.data.data.orders;
                                  let order_Confirmed = [];
                                  let order_Finished = [];
                                  let order_InProcess = [];
                                  let order_Draft = [];
                                  let order_Cancelled = [];
                                  let order_Shipped = [];
                                  let order_Delivered = [];
                                all_orders.forEach((order) => {
                                    switch (order.order_status) {
                                      case 1:
                                        order_Confirmed.push(order);
                                      break;
                                      case 2:
                                        order_Finished.push(order);
                                      break;
                                      case 3:
                                        order_InProcess.push(order);
                                      break;
                                      case 4:
                                        order_Draft.push(order);
                                      break;
                                      case 5:
                                        order_Cancelled.push(order);
                                      break;
                                      case 6:
                                        order_Shipped.push(order);
                                      break;
                                      case 7:
                                        order_Delivered.push(order);
                                      break;
                                    
                                      default:
                                        break;
                                    }
                                  });
                                  setData(all_orders);
                                  setDataConfirmed(order_Confirmed);
                                  setDataFinished(order_Finished);
                                  setDataInproduction(order_InProcess);
                                  setDataDraft(order_Draft);
                                  setDataCancelled(order_Cancelled);
                                  setDataShipped(order_Shipped);
                                  setDataDelivered(order_Delivered);

                                } else {
                                  console.log("API response is not an array");
                                }
                              })
                              .catch((error) => {
                                console.log(error);
                              });

            
                Swal.fire(
                  'Changed!',
                  'Order Status has been changed Successfully.',
                  'success'
                );
                // setTimeout(() => {
                //  // window.location.href = "/orders";
                // }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });


   
  
  }

  function objectToQueryString(obj) {
    return Object.keys(obj)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        .join('&');
}
  const downloadExcel = (e) => {

    console.log(e);
    let order_statss = formData.order_stats;
      let all_status = [];
      order_statss.map((brk, index) => {
        console.log(index);
        all_status.push(brk.value);
    });
    let all_status2 = all_status.toString();
    formData.status = all_status2;
    console.log(formData);

    $("#loader-image2").removeClass('loader-hide2');
    $("#loader-image2").addClass('loader-show2');
    const queryString = objectToQueryString(formData);
    // axios.get(`/orders/listing-excel?${queryString}`,  {
    //          //responseType: 'blob',
    //         headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    //      }).then(response => {
    //       console.log(response);
              window.open(`${base_url}/orders/listing-excel-open?${queryString}`, '_blank');

              $("#loader-image2").addClass('loader-hide2');
              $("#loader-image2").removeClass('loader-show2');
             
          // })
          // .catch(error => {
          //     console.error('Error downloading PDF:', error);
          // });
  }

  const downloadExcelFiltered = (e) => {
    console.log(e);
    console.log(formData);
    let order_statss = formData.order_stats;
      let all_status = [];
      order_statss.map((brk, index) => {
        console.log(index);
        all_status.push(brk.value);
    });
    let all_status2 = all_status.toString();
    formData.status = all_status2;
    console.log(formData);

    $("#loader-image3").removeClass('loader-hide2');
    $("#loader-image3").addClass('loader-show2');
    const queryString = objectToQueryString(formData);
   
              window.open(`${base_url}/orders/listing-excel-open?${queryString}`, '_blank');

       
  }
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />  
      {/* <ToastContainer /> */}

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Production Orders</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Production Orders</li>
                </ul>
              </div>
              <div className="col-auto">
              
                &nbsp;&nbsp;
                  {permission && permission.list === 1 && (
                  <button style={{display:'none'}}
                  className="btn btn-primary"
                  onClick={() => downloadExcel()}
                >
                  <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                </button> 
                )}   
              </div>
            </div>
          </div>
          <div id="filter_inputs" className="card filter-card2">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                <div className="row">
                <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Contract:</label>
                    
                        <Select
                           
                           options={contractslist}
                           name="contract"
                           value={contractslist.find(option => option.value === formData.contract) || null} 
                           onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                          />
                    </div>
                  </div>
                 
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Order Status:</label>
                     
                             <Select
                                isMulti
                                options={options}
                                name="order_stats"
                                value={options.filter(option => formData.order_stats?.includes(option.value))} 
                                onChange={(selectedOptions) => handleSelectChange(selectedOptions)}
                              />

                    </div>
                  </div>
                  
          
                
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/production-orders" className="btn btn-primary me-1"><i className="fa fa-times"></i></a> &nbsp;&nbsp;
                      
                        <button
                          className="btn btn-primary"
                          id="filtered-excel-button"
                         
                          onClick={() => downloadExcelFiltered()}
                        >
                          <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                        
                        </button> 
                    
                      
                        
                    </div>
                  </div>
                </div>
                </form>
                
              </div>
            </div>
         

          <div className="row">
            <div className="col-sm-12">
            {permission && permission.list === 1 && (
            <section className="comp-section order-listing-page">
                <div className="row">
                <div className="col-md-12">
                    <div className="card bg-white">
                    
                    <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-bottom">
                         
                         <li className="nav-item">
                            <a className="nav-link active" href="#all-orders" data-bs-toggle="tab">All Orders ({data.length})</a>                                  
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataConfirmed" data-bs-toggle="tab"> Confirmed Orders ({dataConfirmed.length})</a>                                   
                        </li>                    
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataFinished" data-bs-toggle="tab"> Fnished Orders ({dataFinished.length})</a>                                   
                        </li>                   
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataInproduction" data-bs-toggle="tab"> In Process Orders ({dataInproduction.length})</a>                                   
                        </li>                    
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataDraft" data-bs-toggle="tab"> Draft Orders ({dataDraft.length})</a>                                   
                        </li>                   
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataCancelled" data-bs-toggle="tab"> Cancelled Orders ({dataCancelled.length})</a>                                   
                        </li>                 
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataShipped" data-bs-toggle="tab"> Shipped Orders ({dataShipped.length})</a>                                   
                        </li>                 
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataDelivered" data-bs-toggle="tab"> Delivered Orders ({dataDelivered.length})</a>                                   
                        </li>                    
                                    
                                         
                        </ul>
                        <div className="tab-content">
                     
                        <div className="tab-pane show active" id="all-orders">
                            <div className="row"  id="listing-followup-groupby" >
                              <div className="col-sm-12" >
                              <div className="card card-table">
                                <div className="card-body">
                                  <div className="table-responsive">
                                  <MaterialReactTable columns={columns} data={data} 
                                        enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                       
                                      
                                      />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane " id="list-dataConfirmed">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataConfirmed} 
                                         enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                      
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                
                        
                        <div className="tab-pane " id="list-dataFinished">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataFinished} 
                                         enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                      
                                        
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                
                        
                        <div className="tab-pane " id="list-dataInproduction">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataInproduction} 
                                          enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                        <div className="tab-pane " id="list-dataDraft">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataDraft} 
                                          enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                        <div className="tab-pane " id="list-dataCancelled">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataCancelled} 
                                          enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                    
                        <div className="tab-pane " id="list-dataShipped">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataShipped} 
                                          enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                      
                        <div className="tab-pane " id="list-dataDelivered">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataDelivered} 
                                           enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                                     
                     
                                                     
                        
                        </div>                             
                    </div>
                    </div>
                </div>
                </div>
            </section>
            )}
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProductionOrders;
